import React, { Component } from 'react';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';

import cn from 'classnames';
import styles from './Payment.scss';
import tracker from '../../../../../services/tracker';
import { withTranslation } from 'react-i18next';
import i18n from '../../../../../i18n';
import { gaEvent, trackGA } from 'services/ga';

const getVariants = (t) => ({
  mrt: {
    param: 'mrt',
    key: 'ipoteka',
    text: t('components.header.filtersBar.filters.payment.ipoteka'),
    event: 'Web_Filters_Mortgage',
  },
  inst: {
    param: 'inst',
    key: 'installments',
    text: t('components.header.filtersBar.filters.payment.installments'),
    event: 'Web_Filters_Installment',
  },
  mil: {
    param: 'mil',
    key: 'military_ipoteka',
    text: t('components.header.filtersBar.filters.payment.military_ipoteka'),
    event: 'Web_Filters_Military_Mortgage',
  },
  capt: {
    param: 'capt',
    key: 'mat_capital',
    text: t('components.header.filtersBar.filters.payment.mat_capital'),
    event: 'Web_Filters_Maternity_Capital',
  },
  taxes: {
    param: 'taxes',
    key: 'taxes',
    text: t('components.header.filtersBar.filters.payment.taxes'),
    event: 'Web_Filters_Taxes',
  },
  cash: {
    param: 'cash',
    key: 'cash',
    text: t('components.header.filtersBar.filters.payment.cash'),
    event: 'Web_Filters_Cash',
  },

  fmly: {
    param: 'fmly',
    key: 'is_ipoteka_family',
    text: t('components.header.filtersBar.filters.payment.is_ipoteka_family'),
    event: 'Web_Filters_Ipoteka_Family',
  },
  sup: {
    param: 'sup',
    key: 'is_ipoteka_state_support',
    text: t('components.header.filtersBar.filters.payment.is_ipoteka_state_support'),
    event: 'Web_Filters_Ipoteka_State_Support',
  },
  it: {
    param: 'it',
    key: 'is_ipoteka_it',
    text: t('components.header.filtersBar.filters.payment.is_ipoteka_it'),
    event: 'Web_Filters_Ipoteka_It',
  },
  trnch: {
    param: 'trnch',
    key: 'is_ipoteka_tranche',
    text: t('components.header.filtersBar.filters.payment.is_ipoteka_tranche'),
    event: 'Web_Filters_Ipoteka_Tranche',
  },
  sbsdy: {
    param: 'sbsdy',
    key: 'is_ipoteka_subsidized',
    text: t('components.header.filtersBar.filters.payment.is_ipoteka_subsidized'),
    event: 'Web_Filters_Ipoteka_Subsidized',
  },
  prfntl: {
    param: 'prfntl',
    key: 'is_ipoteka_preferential',
    text: t('components.header.filtersBar.filters.payment.is_ipoteka_preferential'),
    event: 'Web_Filters_Ipoteka_Preferential',
  },
});

export const parseSearch = (search, t) => {
  const { payment } = search;
  if (!payment) {
    return { payment: [] };
  }
  const keys = payment.split(',');
  const variants = getVariants(t);
  return {
    payment: Object.keys(variants).reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.param)) {
        prev.push(variant.key);
      }
      return prev;
    }, []),
  };
};

export const compileSearch = (data, t) => {
  const { payment: keys } = data;
  if (!keys.length) {
    return { payment: undefined };
  }

  const variants = getVariants(t);

  return {
    payment:
      Object.keys(variants)
        .reduce((prev, cur) => {
          const variant = variants[cur];
          if (keys.includes(variant.key)) {
            prev.push(variant.param);
          }
          return prev;
        }, [])
        .join(',') || undefined,
  };
};

export const compileRequest = (data) => {
  const { payment } = data;
  return { paymentOptions: payment.length ? payment : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search, i18n.t));

export const subtext = (search, t) => {
  const { payment: keys } = parseSearch(search, t);
  const variants = getVariants(t);
  return (
    Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.text);
        }
        return prev;
      }, [])
      .join(', ') || i18n.t('components.header.filtersBar.filters.payment.notSelected')
  );
};

class Payment extends Component {
  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { dropdownData, mode, profile, objectType, t } = this.props;
    const data = { payment: [] };
    const compiledSearch = compileSearch(data, t);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick('payment');

    trackGA(
      gaEvent.filterClearButtonsClick({
        eventContent: 'varianty_oplaty',
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData, mode, objectType, profile, t } = this.props;
    const { payment: keys } = parseSearch(search, t);
    const payment = [...keys];
    const variants = getVariants(t);

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    const variant = variants[Object.keys(variants).find((v) => variants[v].key === key)];
    const variantName = variant ? variant.text : 'Unknown variant';
    const isChecked = add ? 'on' : 'off';

    trackGA(
      gaEvent.filterCheckboxesClick({
        eventContent: [variantName, ` | ${isChecked}`],
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );

    if (payment.includes(key) !== add) {
      if (add) {
        payment.push(key);
      } else {
        payment.splice(payment.indexOf(key), 1);
      }
    }

    const data = { payment };
    const compiledSearch = compileSearch(data, t);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, additional, t } = this.props;
    const { payment } = parseSearch(search, t);
    const variants = getVariants(t);
    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={payment.includes(variant.key)}
        additional={additional}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        text={variant.text}
      />
    );
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { payment } = parseSearch(search, t);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.payment.title')}
          {!additional
            ? !!payment.length && (
                <Button className={styles.Button} onClick={this.handleClearClick}>
                  {t('components.header.filtersBar.filters.payment.clear')}
                </Button>
              )
            : null}
        </p>
        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {this.checkbox('taxes')}
            {this.checkbox('cash')}

            {this.checkbox('mrt')}
            {this.checkbox('mil')}
            {this.checkbox('fmly')}
            {this.checkbox('sup')}
          </div>
          <div className={styles.SecondColumn}>
            {this.checkbox('capt')}
            {this.checkbox('inst')}

            {this.checkbox('it')}
            {this.checkbox('trnch')}
            {this.checkbox('sbsdy')}
            {this.checkbox('prfntl')}
          </div>
        </div>
        {additional ? (
          <div className={styles.ButtonWrap}>
            {!!payment.length && (
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.payment.clear')}
              </Button>
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

export default withTranslation()(Payment);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Payment/Payment.js